module.exports = new __parcel__URL__("space_elixir_icon.e844e9d0.png").toString();